import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceFingerprintService {
  async getDeviceFingerprint(): Promise<string> {
    const raw = [
      navigator.userAgent ?? '',
      navigator.language ?? '',
      Intl.DateTimeFormat().resolvedOptions().timeZone ?? '',
      String(screen.width ?? ''),
      String(screen.height ?? ''),
      navigator.platform ?? '',
      navigator.vendor ?? ''
    ].join('|');

    return this.sha256(raw);
  }

  getDeviceName(): string {
    const ua = navigator.userAgent || '';

    const browser =
      ua.includes('Edg') ? 'Edge' :
      ua.includes('Chrome') ? 'Chrome' :
      ua.includes('Firefox') ? 'Firefox' :
      ua.includes('Safari') ? 'Safari' :
      'Browser';

    const os =
      ua.includes('Windows') ? 'Windows' :
      ua.includes('Mac OS') ? 'MacOS' :
      ua.includes('Android') ? 'Android' :
      /iPhone|iPad|iPod/.test(ua) ? 'iOS' :
      ua.includes('Linux') ? 'Linux' :
      'Unknown OS';

    return `${browser} on ${os}`;
  }

  private async sha256(value: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
}